// Configuração da aba/modal de Participantes por segmento da organização —
// pedido da usuária: o rótulo e os textos de exemplo devem soar certos pro
// negócio (petshop fala de animal, oficina de veículo, etc.), não um texto
// genérico misturando tudo. Chave = segmentos.nome (ver migration 123).
export const CONFIG_PARTICIPANTE = {
  'Petshop': {
    labelAba: 'Animais',
    labelSingular: 'Animal',
    nomePlaceholder: 'Ex.: Rex, Bidu, Mimi...',
    tipoPlaceholder: 'Cão, Gato, Ave...',
    tipoSugestoes: ['Cão', 'Gato', 'Ave', 'Outro'],
    detalhesPlaceholder: 'Espécie/raça/porte, cor, idade, ou qualquer outra observação...',
  },
  'Oficinas Mecânicas': {
    labelAba: 'Veículos',
    labelSingular: 'Veículo',
    nomePlaceholder: 'Ex.: Fusca placa ABC-1234, Gol prata...',
    tipoPlaceholder: 'Carro, Moto, Caminhão...',
    tipoSugestoes: ['Carro', 'Moto', 'Caminhão', 'Outro'],
    detalhesPlaceholder: 'Placa/modelo/ano/cor, ou qualquer outra observação...',
  },
  'Assistência Técnica': {
    labelAba: 'Equipamento/Máquina',
    labelSingular: 'Equipamento',
    nomePlaceholder: 'Ex.: Notebook Dell, Furadeira Bosch...',
    tipoPlaceholder: 'Notebook, Celular, Máquina industrial...',
    tipoSugestoes: ['Notebook', 'Celular', 'Máquina', 'Outro'],
    detalhesPlaceholder: 'Marca/modelo/número de série, ou qualquer outra observação...',
  },
  // Sem rótulo explícito da usuária pra Clínicas — "Dependentes" cobre tanto
  // clínica médica/odontológica (filho, cônjuge) quanto psicológica/estética.
  // Fácil de ajustar aqui se ela preferir outro termo.
  'Clínicas': {
    labelAba: 'Dependentes',
    labelSingular: 'Dependente',
    nomePlaceholder: 'Ex.: Maria (filha), João (pai)...',
    tipoPlaceholder: 'Filho(a), Cônjuge, Pai/Mãe...',
    tipoSugestoes: ['Filho(a)', 'Cônjuge', 'Pai/Mãe', 'Outro'],
    detalhesPlaceholder: 'Idade, condição, ou qualquer outra observação...',
  },
};

export const PADRAO_PARTICIPANTE = {
  labelAba: 'Participantes',
  labelSingular: 'Participante',
  nomePlaceholder: 'Ex.: Rex, Fusca placa ABC-1234...',
  tipoPlaceholder: 'Animal, Veículo, Dependente...',
  tipoSugestoes: ['Animal de estimação', 'Veículo', 'Dependente', 'Equipamento'],
  detalhesPlaceholder: 'Espécie/raça/porte, placa/modelo/ano, ou qualquer outra observação...',
};

export function configParticipante(segmentoNome) {
  return CONFIG_PARTICIPANTE[segmentoNome] || PADRAO_PARTICIPANTE;
}
